<template>
  <div>
    <portal to="cardActions">
      <div class="d-flex align-center mb-3">
        <div>
          <span class="caption grey--text text--darken-1"
            >Adicionar variáveis</span
          >
          <v-select
            v-model="selectedComponents"
            item-text="label"
            item-value="id"
            :items="allVariables"
            solo
            hide-details
            class="thin-border small-items"
            multiple
            dense
            :disabled="showUsersAutonomy"
            style="max-width: 400px"
          />
        </div>
        <div class="ml-3">
          <span class="caption grey--text text--darken-1"
            >Autonomia - Colegas:</span
          >
          <v-switch
            class="mt-0"
            v-model="showUsersAutonomy"
            hide-details
          ></v-switch>
        </div>
      </div>
    </portal>
    <table
      v-if="!showUsersAutonomy"
      :style="cssVars"
      :class="style.borders ? 'bordered' : ''"
      class="styled-table"
    >
      <template>
        <tr class="border-top" style="text-align: center !important">
          <td colspan="2" class="categ-title"></td>
          <td colspan="2" class="categ-title">Cirurgião</td>
          <td
            colspan="2"
            class="categ-title"
            style="text-align: center !important"
          >
            Ajudante
          </td>
          <td
            colspan="2"
            class="categ-title"
            style="text-align: center !important"
          >
            Observador
          </td>
          <td
            class="categ-title extra-pad"
            style="text-align: center !important"
          >
            Total
          </td>
        </tr>
        <template v-for="(component, index) in tableValues">
          <tr
            :key="index + component.name + item.name + key"
            v-for="(item, key) in component.values"
          >
            <template>
              <td
                v-if="component.isParent && key === 0"
                :key="item.name + key"
                :rowspan="component.values.length"
              >
                {{ component.name }}
              </td>
              <td
                :colspan="key === 0 && !component.isParent ? 2 : 0"
                :key="index + item.name + key"
                style="text-align: center !important; min-width: 100px"
                class="subcateg-title pl-4"
              >
                <span>{{ item.name }}</span>
              </td>
              <td :key="'surgeon' + key" style="text-align: center !important">
                {{ item.surgeonCount === 0 ? '-' : item.surgeonCount }}
              </td>
              <td :key="'sper' + key" style="text-align: center !important">
                {{
                  getPercent(item.surgeonCount, item.total) === '0%'
                    ? '-'
                    : getPercent(item.surgeonCount, item.total)
                }}
              </td>
              <td :key="'help' + key" style="text-align: center !important">
                {{ item.helperCount === 0 ? '-' : item.helperCount }}
              </td>
              <td :key="'helperc' + key" style="text-align: center !important">
                {{
                  getPercent(item.helperCount, item.total) === '0%'
                    ? '-'
                    : getPercent(item.helperCount, item.total)
                }}
              </td>
              <td :key="'obsr' + key" style="text-align: center !important">
                {{ item.observerCount === 0 ? '-' : item.observerCount }}
              </td>
              <td :key="'obsrper' + key" style="text-align: center !important">
                {{
                  getPercent(item.observerCount, item.total) === '0%'
                    ? '-'
                    : getPercent(item.observerCount, item.total)
                }}
              </td>
              <td :key="'total' + key" style="text-align: center !important">
                {{ item.total }}
              </td>
            </template>
          </tr>
        </template>
      </template>
    </table>

    <table
      v-if="showUsersAutonomy"
      :style="cssVars"
      :class="style.borders ? 'bordered' : ''"
      class="styled-table"
    >
      <template>
        <tr class="border-top" style="text-align: center !important">
          <td colspan="2" class="categ-title" style="min-width: 200px"></td>
          <td colspan="2" class="categ-title">Cirurgião</td>
          <td
            colspan="2"
            class="categ-title"
            style="text-align: center !important"
          >
            Ajudante
          </td>
          <td
            colspan="2"
            class="categ-title"
            style="text-align: center !important"
          >
            Observador
          </td>
          <td
            class="categ-title extra-pad"
            style="text-align: center !important"
          >
            Total
          </td>
        </tr>
        <template v-for="(component, index) in userValues">
          <tr :key="index + item.name" v-for="(item, key) in component.values">
            <template>
              <td
                v-if="key === 0 && component.values.length > 1"
                :rowspan="component.values.length"
              >
                {{ component.name }}
              </td>
              <td
                :colspan="key === 0 && component.values.length === 1 ? 2 : 0"
                :key="item.name + key"
                style="text-align: center !important"
                class="subcateg-title pl-4"
              >
                <span>{{ item.name }}</span>
              </td>
              <td :key="'surgeon' + key" style="text-align: center !important">
                {{ item.surgeonCount }}
              </td>
              <td :key="'sper' + key" style="text-align: center !important">
                {{ getPercent(item.surgeonCount, item.total) }}
              </td>
              <td :key="'help' + key" style="text-align: center !important">
                {{ item.helperCount }}
              </td>
              <td :key="'helperc' + key" style="text-align: center !important">
                {{ getPercent(item.helperCount, item.total) }}
              </td>
              <td :key="'obsr' + key" style="text-align: center !important">
                {{ item.observerCount }}
              </td>
              <td :key="'obsrper' + key" style="text-align: center !important">
                {{ getPercent(item.observerCount, item.total) }}
              </td>
              <td :key="'total' + key" style="text-align: center !important">
                {{ item.total }}
              </td>
            </template>
          </tr>
        </template>
      </template>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import helpers from '../mixins/statsHelperFunc'
import { UsersIdInfo } from '../../../models/UsersInfo'
import batchSplit from '../../../utils/batchSplit'
import { AgeOption } from '@/models/Content'
export default {
  props: {
    logs: { type: Array },
    logbookType: { type: String }
  },
  mixins: [helpers],
  data() {
    return {
      selectedComponents: [],
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#ffffff']
      },
      inpatientTotal: 0,
      apointmentTotal: 0,
      showUsersAutonomy: false
    }
  },
  computed: {
    ...mapGetters(['user']),
    cssVars() {
      return {
        '--bg-color': this.style.colors[0],
        '--bg-light-color': this.style.colors[0] + 20,
        '--bg-odd-color': this.style.colors[0] + 40,
        '--categ-color': this.style.colors[0] + 99,
        '--subcateg-color': this.style.colors[0] + 60,
        '--border-collapse': this.style.borders ? 'collapse' : 'inherit',
        '--border-color': this.style.borderColor,
        '--accent-border-color': this.style.borderColor + 50
      }
    },
    allVariables() {
      let components = this.allStatsComponents(this.logbookType)
      components = components.filter(
        component =>
          component.id !== 'anatomic-region' && component.id !== 'internship'
      )
      return components
    },
    ageOptions() {
      return AgeOption.query().get()
    },
    tableValues() {
      let items = {
        autonomy: {
          name: 'Autonomia',
          isParent: false,
          values: [
            {
              name: 'Autonomia',
              id: 'autonomy',
              surgeonCount: 0,
              helperCount: 0,
              observerCount: 0
            }
          ]
        }
      }
      if (this.selectedComponents.length > 0) {
        this.selectedComponents.map(component => {
          const fullComponent = this.allVariables.find(
            item => item.id === component
          )
          const values = []

          if (fullComponent.id === 'age') {
            fullComponent.options = this.ageOptions
          }

          if (fullComponent.options.length > 0) {
            fullComponent.options.forEach(option => {
              values.push({
                name: option.text,
                id: option.value,
                surgeonCount: 0,
                helperCount: 0,
                observerCount: 0
              })
            })
          } else {
            values.push({
              name: fullComponent.label,
              id: fullComponent.id,
              surgeonCount: 0,
              helperCount: 0,
              observerCount: 0
            })
          }
          items[component] = {
            name: fullComponent.label,
            type: fullComponent.type,
            isParent:
              values.length > 1 || fullComponent.label !== values[0].name,
            values: values
          }
        })
      }

      this.logs.map(log => {
        if (this.isSurgeon(log)) {
          items['autonomy'].values[0].surgeonCount++
        }
        if (this.isHelper(log)) {
          items['autonomy'].values[0].helperCount++
        }
        if (this.isObserver(log)) {
          items['autonomy'].values[0].observerCount++
        }
        if (this.isSurgeon(log) || this.isHelper(log) || this.isObserver(log))
          this.selectedComponents.map(component => {
            if (log[component]) {
              if (Array.isArray(log[component]) && log[component].length > 0) {
                log[component].forEach(logValue => {
                  logValue.text
                    ? (logValue.name = logValue.text)
                    : (logValue = { name: logValue })
                  const index = items[component].values.findIndex(
                    value =>
                      logValue.name.includes(value.id) ||
                      logValue.name.includes(value.name)
                  )
                  this.isSurgeon(log)
                    ? items[component].values[index].surgeonCount++
                    : ''
                  this.isHelper(log)
                    ? items[component].values[index].helperCount++
                    : ''
                  this.isObserver(log)
                    ? items[component].values[index].observerCount++
                    : ''
                })
              } else if (items[component].type === 'checkbox') {
                this.isSurgeon(log)
                  ? items[component].values[0].surgeonCount++
                  : ''
                this.isHelper(log)
                  ? items[component].values[0].helperCount++
                  : ''
                this.isObserver(log)
                  ? items[component].values[0].observerCount++
                  : ''
              } else {
                const index = items[component].values.findIndex(
                  value =>
                    log[component].toString().includes(value.id) ||
                    log[component].toString().includes(value.name)
                )
                this.isSurgeon(log)
                  ? items[component].values[index].surgeonCount++
                  : ''
                this.isHelper(log)
                  ? items[component].values[index].helperCount++
                  : ''
                this.isObserver(log)
                  ? items[component].values[index].observerCount++
                  : ''
              }
            }
          })
      })

      Object.keys(items).map(item => {
        items[item].values.forEach((value, index) => {
          items[item].values[index].total = Object.values(
            items[item].values[index]
          )
            .slice(2, 5)
            .reduce((a, b) => a + b)
        })
        items[item].values = items[item].values.filter(
          value => value.total !== 0
        )
      })
      return items
    },
    userValues() {
      let items = {
        autonomy: {
          name: 'Autonomia',
          values: [
            {
              name: this.user.name,
              id: 'autonomy',
              surgeonCount: 0,
              helperCount: 0,
              observerCount: 0
            }
          ]
        }
      }

      let users = []

      this.logs.forEach(log => {
        log['surgeon'] && !users.includes(log['surgeon'])
          ? users.push(log['surgeon'])
          : ''
        log['helper-1'] && !users.includes(log['helper-1'])
          ? users.push(log['helper-1'])
          : ''
        log['helper-2'] && !users.includes(log['helper-2'])
          ? users.push(log['helper-2'])
          : ''
        log['helper-3'] && !users.includes(log['helper-3'])
          ? users.push(log['helper-3'])
          : ''
        log['observer'] && !users.includes(log['observer'])
          ? users.push(log['observer'])
          : ''
      })
      users = users.filter(user => user !== this.user.id)

      this.getUserNamesList(users)

      users.forEach(user => {
        const username =
          this.getUser(user).length > 0
            ? this.getUser(user)[0].firstName +
              ' ' +
              this.getUser(user)[0].lastName
            : user
        items[user] = {
          name: 'Autonomia',
          values: [
            {
              name: username,
              id: 'autonomy',
              surgeonCount: 0,
              helperCount: 0,
              observerCount: 0
            }
          ]
        }
      })

      this.logs.map(log => {
        if (this.isSurgeon(log)) {
          items['autonomy'].values[0].surgeonCount++
        }
        if (this.isHelper(log)) {
          items['autonomy'].values[0].helperCount++
        }
        if (this.isObserver(log)) {
          items['autonomy'].values[0].observerCount++
        }

        users.map(user => {
          if (log['surgeon'] === user) {
            items[user].values[0].surgeonCount++
          }
          if (
            log['helper-1'] === user ||
            log['helper-2'] === user ||
            log['helper-3'] === user
          ) {
            items[user].values[0].helperCount++
          }
          if (log['observer'] === user) {
            items[user].values[0].observerCount++
          }
        })
      })

      Object.keys(items).map(item => {
        items[item].values.forEach((value, index) => {
          items[item].values[index].total = Object.values(
            items[item].values[index]
          )
            .slice(2, 5)
            .reduce((a, b) => a + b)
        })
      })

      return items
    },
    availableComponents() {
      return this.allComponents.filter(
        item => !this.selectedComponents.includes(item)
      )
    }
  },
  methods: {
    isSurgeon(log) {
      if (
        log['surgeon'] === this.user.id ||
        log['surgeon'] === this.user.license
      ) {
        return true
      }
    },
    isHelper(log) {
      if (
        log['helper-1'] === this.user.id ||
        log['helper-1'] === this.user.license
      ) {
        return true
      }
      if (
        log['helper-2'] === this.user.id ||
        log['helper-2'] === this.user.license
      ) {
        return true
      }
      if (
        log['helper-3'] === this.user.id ||
        log['helper-3'] === this.user.license
      ) {
        return true
      }
    },
    isObserver(log) {
      if (
        log['observer'] === this.user.id ||
        log['observer'] === this.user.license
      ) {
        return true
      }
    },
    getPercent(parcial, total) {
      const result = Math.round((parcial / total) * 100)
      return isNaN(result) ? '-' : result + '%'
    },
    async getUserNamesList(UserIdsList) {
      if (UserIdsList.length) {
        const batchesUsers = batchSplit(UserIdsList, 10)
        await UsersIdInfo.fetch(
          this.$store.getters.accessToken,
          batchesUsers
        ).catch(err => {
          return this.$store.dispatch(
            'showErrorSnackbar',
            err.message || 'Something went wrong'
          )
        })
      }
    },
    getUser(UserId) {
      if (UserId) {
        const userNames = UsersIdInfo.query().get()
        return userNames.filter(user => user.id === UserId)
      }
    }
  },
  mounted() {
    this.$root.$emit('isTable', true)
    this.$root.$on('selectedStyle', style => {
      this.style = style
    })
  }
}
</script>

<style>
.small-items {
  font-size: 12px !important;
}
</style>
